<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row" v-if="loadStatus == 0">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <loading />
                </div>
            </div>

            <div class="row" v-else>
                <div class="col-sm-12 col-md-7 col-lg-8">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div :class="'registered-product-item guest ' + (vg_loggedIn_user_id == product_detail.owner_id ? 'mine' : 'guest')">
                                <router-link :to="{name: 'CustomerRegisteredProducts'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Product Details</h3>
                                <ul>
                                    <li>
                                        <span class="semibold">Model</span>
                                        <span class="normal truncate">{{ form.product_model }}</span>
                                    </li>
                                    <li>
                                        <span class="semibold">Serial number</span>
                                        <div class="d-flex gap-2">
                                            <span class="normal mr-1" v-if="form.order_number">
                                                {{ form.order_number }}
                                            </span>
                                            <span class="normal">
                                                {{ (form.order_number ? ' - ' : '') + (form.sku_number ? form.sku_number + ' - ' : '') }}
                                            </span>
                                            <span class="normal truncate ml-1">{{ form.serial_number }}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="purchased_date"
                                                placeholder="yy-mm-dd"
                                                :disabled-dates="{from: new Date()}"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date:</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="yy-mm-dd"
                                                :disabled-dates="{from: new Date()}"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="semibold">Place of purchase:</span>
                                        <span><input type="text" v-model="form.place_of_purchase" /></span>
                                    </li>
                                    <li>
                                        <file-uploader mode="view" label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>
                                    <li>
                                        <span class="semibold">Installation compliance</span>
                                        <span class="mt-1 d-flex flex-column cursor-pointer no-border">
                                            <label class="mr-2 font-normal" for="with_coc" v-if="form.installation_compliance == 'with_coc'">
                                                Installed with COC
                                            </label>

                                            <label class="mr-2 font-normal" for="with_coc" v-if="form.installation_compliance == 'without_coc'">
                                                Installed delayed
                                            </label>

                                            <label class="mr-2 font-normal" for="without_coc" v-if="form.installation_compliance == 'no_coc'">
                                                No COC</label
                                            >
                                        </span>
                                    </li>
                                    <ul v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semibold">Coc number:</span>
                                            <span> <input type="text" v-model="form.coc_number" /></span>
                                        </li>
                                        <li class="border-b-1">
                                            <file-uploader mode="view" label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </ul>
                                </ul>
                                <!-- <button class="btn btn-primary mt-3" @click.prevent="updateRegProduct()">UPDATE PRODUCT</button> -->
                            </div>

                            <ticket-box
                                class="mt-4"
                                :ticket_status="ticket_status"
                                :ticket_type="ticket_type"
                                :tickets="ticketMessages"
                                :form="form"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-5 col-lg-4">
                    <div class="card">
                        <div class="card-body">
                            <div class="change-product-seller">
                                <h5 class="mb-0">Purchased From:</h5>
                                <h3>
                                    <span class="focus-primary" v-if="isEmpty(sellerObj) == false">{{
                                        sellerObj ? sellerObj.company : '-----'
                                    }}</span>
                                </h3>
                                <p v-if="isEmpty(sellerObj) == false">
                                    <span class="d-block" v-if="sellerObj.company">{{ sellerObj.company ? sellerObj.company : '' }} </span>
                                    <span class="d-block" v-if="sellerObj.mobile">{{ sellerObj.mobile ? sellerObj.mobile : '' }} </span>
                                    <span class="d-block" v-if="sellerObj.email">{{ sellerObj.email ? sellerObj.email : '' }} </span>
                                </p>
                                <template v-if="product_detail.owner_id == vg_loggedIn_user_id">
                                    <p class="mb-0 text-primary"><small>please select one from suggesions</small></p>
                                    <vue-autosuggest
                                        :suggestions="sellerSuggestions"
                                        :input-props="{
                                            class: 'form-control',
                                            id: 'autosuggest_seller_input',
                                            placeholder: 'Change Purchased From'
                                        }"
                                        @input="onChangeSellerInput"
                                        @selected="selectSellerHandler"
                                        @click="onChangeSellerInput"
                                        :getSuggestionValue="getSuggestionValue"
                                    >
                                        <template slot-scope="{suggestion}">
                                            <span class="my-suggestion-item">{{
                                                suggestion.item.company ? suggestion.item.company : suggestion.item.email
                                            }}</span>
                                        </template>
                                    </vue-autosuggest>
                                    <button class="btn btn-primary mt-3" @click.prevent="updateSeller()">Update</button>
                                </template>
                            </div>
                        </div>
                    </div>
                    <assign-ownership :product_detail="product_detail" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import {VueAutosuggest} from 'vue-autosuggest';
import {mapGetters, mapActions} from 'vuex';
import * as _ from 'lodash';
import moment from 'moment';
import TicketBox from '@/components/WarrantyRepairBox.vue';
import AssignOwnership from '@/views/customer/pageComponents/AssignOwnership.vue';
import bus from '@/bus';

export default {
    components: {
        VueAutosuggest,
        TicketBox,
        AssignOwnership
    },
    name: 'customerRegProductEdit',
    data() {
        return {
            loadStatus: 0,
            subscribedChannel: false,
            message: '',
            loadCount: 0,
            loaded: false,
            seller: '',
            sellerObj: {
                id: '',
                company: ''
            },
            sellerSuggestions: [
                {
                    data: []
                }
            ],
            coc_certificate_change: '',
            serial_number_max_length: 6,

            ticketMessages: [],
            ticket_status: '',
            ticket_type: '',

            form: {
                id: '',
                hasOrderNumber: false,
                product_model: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                place_of_purchase: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                invoice_number: '',
                purchased_from: '',
                open_ticket_request: false,
                has_open_ticket: false,
                coc_certificate: {
                    incoming_url: '',
                    url: '',
                    data: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },

                purchased_from_role: 'reseller',
                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                }
            },
            product_detail: {}
        };
    },

    computed: {
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid'
        })
    },

    async mounted() {
        let res = await this.fetchProductDetail();
        if (res) {
            this.subscribeProductChannel(res);
        }
        bus.$on('warranty-repair-box-refetch', () => {
            this.fetchProductDetail();
        });
    },

    methods: {
        /**
         * subscribe pubnub
         */
        async subscribeProductChannel(res) {
            const self = this;
            if (this.subscribedChannel == false) {
                let channels = [];
                channels.push(res.sku_with_serial_number);
                this.$pnSubscribe({channels: channels});
                this.$pnGetMessage(res.sku_with_serial_number, this.receiveEmit);
                this.subscribedChannel == true;
                console.log('subscribedChannel', this.subscribedChannel);
            }
        },

        receiveEmit() {
            console.log('emit');
            this.fetchProductDetail();
        },

        readAbleTime(str) {
            return moment(str).format('YYYY-MM-DD hh:mm a');
        },

        /**
         * Update seller
         */
        async updateSeller() {
            if (this.seller == '') {
                return this.$toasted.global.error({
                    message: 'Please select seller.'
                });
            }
            if (this.sellerObj.id) {
                const url = `${Env.baseUrl}/customer/reg-product/update/seller/${this.form.id}`;
                AuthApis.postApi(url, {purchased_from: this.sellerObj.id})
                    .then((res) => {
                        this.$toasted.global.success({
                            message: 'Successfully updated.'
                        });
                        this.fetchProductDetail();
                    })
                    .catch((err) => {
                        this.$toasted.global.error({
                            message: err.response.data.errors[0]
                        });
                    });
            } else {
                this.$toasted.global.error({
                    message: 'Sorry cannot find seller detail.'
                });
            }
        },

        /**
         * Update
         */
        // updateRegProduct() {
        //     return false; // customer cannot update their added product
        //     // cannot updte model / serials
        //     const url = `${Env.baseUrl}/customer/reg-product/update/${this.form.id}`;
        //     this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
        //     AuthApis.postApi(url, this.form)
        //         .then((res) => {
        //             this.$toasted.global.success({
        //                 message: 'Successfully Updated.'
        //             });
        //             //this.$router.push({ name: 'CustomerRegisteredProducts'});
        //         })
        //         .catch((err) => {
        //             this.$toasted.global.error({
        //                 message: err.response.data.errors[0]
        //             });
        //         });
        // },

        /**
         * Fetch product detail
         */
        async fetchProductDetail() {
            this.loaded = false;
            const url = `${Env.baseUrl}/customer/reg-product/show/${this.$route.params.id}`;
            return AuthApis.getApi(url)
                .then(async (res) => {
                    this.ticketMessages = res.data.payload.tickets ? res.data.payload.tickets : [];
                    this.ticket_status = res.data.payload.ticket_status;
                    this.ticket_type = res.data.payload.ticket_type;

                    this.product_detail = res.data.payload;
                    this.form.id = res.data.payload.id;
                    // just to display
                    this.form.product_model = res.data.payload.product_model;
                    this.form.serial_number = res.data.payload.serial_number;
                    this.form.sku_number = res.data.payload.sku_number;
                    this.form.order_number = res.data.payload.order_number;
                    this.form.hasOrderNumber = res.data.payload.order_number ? true : false;
                    this.form.date_of_purchase = res.data.payload.date_of_purchase;
                    this.form.installation_date = res.data.payload.installation_date;
                    this.form.place_of_purchase = res.data.payload.place_of_purchase;
                    this.form.coc_number = res.data.payload.coc_number;

                    this.form.proof_of_purchase.incoming_url = res.data.payload.proof_of_purchase;
                    this.form.coc_certificate.incoming_url = res.data.payload.coc_certificate;

                    this.form.invoice_number = res.data.payload.invoice_number;
                    this.form.open_ticket_request = res.data.payload.open_ticket_request;
                    this.form.has_open_ticket = res.data.payload.has_open_ticket;
                    this.form.purchased_from = res.data.payload.purchased_from ? res.data.payload.purchased_from.id : '';
                    this.form.purchased_from_role = res.data.payload.purchased_from.role ? res.data.payload.purchased_from.role : 'reseller';

                    this.form.installation_compliance = res.data.payload.installation_compliance
                        ? res.data.payload.installation_compliance
                        : 'no_coc';

                    this.sellerObj = res.data.payload.purchased_from;
                    this.loaded = true;

                    if (this.loadStatus == 0) {
                        this.loadStatus = 1;
                    }
                    // now scroll this div to bottom
                    // display_messages
                    this.$nextTick(() => {
                        var messageDiv = document.getElementById('display_messages');
                        if (messageDiv) {
                            messageDiv.scrollTop = messageDiv.scrollHeight;
                        }
                    });
                    return res.data.payload;
                })
                .catch((err) => {
                    this.$toasted.global.error({
                        message: err.response.data.message
                    });
                    this.$router.push({name: 'CustomerRegisteredProducts'});
                    return false;
                });
        },

        onChangeSellerInput: _.debounce(function (company) {
            this.form.reseller = '';
            const url = `${Env.baseUrl}/customer/seller/suggest`;
            AuthApis.postApi(url, {
                name: company
            })
                .then((res) => {
                    this.sellerSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 500),

        selectSellerHandler(obj) {
            if (obj) {
                this.sellerObj = obj.item;
                this.seller = obj.item.company ? obj.item.company : obj.item.email;
            }
        },
        getSuggestionValue(obj) {
            return obj.item.company ? obj.item.company : obj.item.email;
        },
        isEmpty(obj) {
            if (_.isEmpty(obj)) {
                return true;
            }
            return false;
        },
        showPdf(key) {
            this.va_showPdf(true);
            this.va_setPdfObj({...this.product_detail, ...{target_key: key}});
        },

        /**
         * proofOfPurchaseChanged
         */

        async proofOfPurchaseChanged(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            // file type cehck
            if (this.$refs.proofOfPurchase.files[0].type != 'application/pdf') {
                document.getElementById('proofOfPurchase').value = '';
                this.$toasted.global.error({
                    message: 'Only pdf files are allowed.'
                });
                return;
            }

            // filesize prevent
            let limit5Mb = 5 * 1000000; // 5 MB limit
            if (this.$refs.proofOfPurchase.files[0].size > limit5Mb) {
                document.getElementById('proofOfPurchase').value = '';
                this.snackbar({
                    message: 'Sorry file cannot be more than 5MB.',
                    type: 'warning'
                });
                return;
            }
            //this.coc_certificate_change = this.$refs.proofOfPurchase.files[0].name;
            this.form.proof_of_purchase = {
                url: URL.createObjectURL(files[0]),
                file: files[0],
                name: this.$refs.proofOfPurchase.files[0].name,
                type: this.$refs.proofOfPurchase.files[0].type,
                size: this.$refs.proofOfPurchase.files[0].size
            };
        },

        ...mapActions({
            va_showPdf: 'pdf/setActive',
            va_setPdfObj: 'pdf/setActiveObj'
        })
    },

    beforeDestroy() {
        if (this.product_detail.sku_with_serial_number) {
            let channels = [];
            channels.push(this.product_detail.sku_with_serial_number);
            this.$pnUnsubscribe({channels: channels});
        }
        bus.$off('warranty-repair-box-refetch');
    }
};
</script>
